export default "__VITE_ASSET__q$Hvh1fH__";